import { render, staticRenderFns } from "./my-popup.vue?vue&type=template&id=4811f003&scoped=true&"
import script from "./my-popup.vue?vue&type=script&lang=js&"
export * from "./my-popup.vue?vue&type=script&lang=js&"
import style0 from "./my-popup.vue?vue&type=style&index=0&id=4811f003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811f003",
  null
  
)

export default component.exports